import './../../css-dev/admin/admin.scss';
import jQuery from 'jquery';
//import * from './utils';

'use strict';

(function ($) {

})(jQuery);